import { render } from "./PricingPage.vue?vue&type=template&id=413ef391&scoped=true"
import script from "./PricingPage.vue?vue&type=script&lang=js"
export * from "./PricingPage.vue?vue&type=script&lang=js"

import "./PricingPage.vue?vue&type=style&index=0&id=413ef391&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-413ef391"]])

export default __exports__